import { ListItemText } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

import ColormapInterface from 'shared-types/colormapinterface';
import { fontSize, getSpacing, fontWeight, lineHeight } from 'stylesheetB2b';

import { textCommonStyle } from '../../../../SongList/SongList.style';

const LIST_ITEM_LEFT_RIGHT_PADDING = getSpacing(2);


export const getStyledLastSongListItemText = (colors: ColormapInterface) => {
  const StyledLastSongListItemText = muiStyled(ListItemText)(() => ({
    '.MuiListItemText-primary': {
      ...textCommonStyle,
      fontWeight: fontWeight.bold,
      paddingLeft: LIST_ITEM_LEFT_RIGHT_PADDING,
      paddingRight: LIST_ITEM_LEFT_RIGHT_PADDING,
      fontSize: fontSize.extraSmall,
      lineHeight: lineHeight.small,
      color: colors.lastSongText,
    },
    '.MuiListItemText-secondary': {
      ...textCommonStyle,
      paddingLeft: LIST_ITEM_LEFT_RIGHT_PADDING,
      paddingRight: LIST_ITEM_LEFT_RIGHT_PADDING,
      fontSize: fontSize.extraSmall,
      fontWeight: fontWeight.light,
      lineHeight: lineHeight.small,
      color: colors.lastSongText,
    },
  }));
  return StyledLastSongListItemText;
};
